module.exports = __webpack_public_path__ + "static/img/bg-clean.8a830cd6.png";